/* tslint:disable:jsx-no-lambda WI:47653 */
import TextSuggestionSegment from './TextSuggestionSegment';
import PeopleSuggestionSegment from '../components/PeopleSuggestionSegment';
import { SegmentScenario } from '../store/schema/SegmentScenario';
import { observer } from 'mobx-react';
import { assertNever } from 'owa-assert';
import { SubstrateSearchSuggestionSegment } from 'owa-search-service';
import * as React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';

const searchBoxPillWellStyles = require('./SearchBoxPillWell.scss');
const classNames = require('classnames');

export interface SuggestionSegmentProps {
    isSelected?: boolean;
    onRemoveSegment?: (segmentKey: string) => void;
    scenario: SegmentScenario;
    segment: SubstrateSearchSuggestionSegment;
}

@observer
export default class SuggestionSegment extends React.Component<SuggestionSegmentProps, {}> {
    private suggestionPillDiv: HTMLElement;

    componentDidUpdate() {
        if (this.props.isSelected) {
            this.suggestionPillDiv.focus();
        }
    }

    render() {
        const { onRemoveSegment, scenario, segment } = this.props;

        // Show "X" button if segment is being represented as a pill.
        const isRemoveButtonVisible = scenario === 'SuggestionPill' && !!onRemoveSegment;

        if (scenario === 'SuggestionPill') {
            const segmentContainerClassNames = classNames(
                searchBoxPillWellStyles.personaPillContainer,
                this.props.isSelected && searchBoxPillWellStyles.selected
            );

            return (
                <div
                    className={segmentContainerClassNames}
                    ref={ref => (this.suggestionPillDiv = ref)}
                    tabIndex={-1}>
                    {this.getSegmentPart()}
                    {isRemoveButtonVisible && (
                        <IconButton
                            className={searchBoxPillWellStyles.removePersonaIcon}
                            iconProps={{
                                iconName: ControlIcons.Cancel,
                                styles: {
                                    root: searchBoxPillWellStyles.cancelIcon,
                                },
                            }}
                            onClick={() => onRemoveSegment(segment.DisplayText /* segmentKey */)}
                        />
                    )}
                </div>
            );
        } else {
            return this.getSegmentPart();
        }
    }

    private getSegmentPart() {
        const { segment, scenario } = this.props;

        switch (segment.Type) {
            case 'Text': {
                return <TextSuggestionSegment segment={segment} />;
            }
            case 'Person':
                return (
                    <PeopleSuggestionSegment
                        emailAddress={segment.EmailAddress}
                        name={segment.DisplayName}
                        personaType="User"
                        scenario={scenario}
                        segment={segment}
                    />
                );
            default:
                return assertNever(segment);
        }
    }
}
